export enum ComputersAndVirtualMachinesGridEvents {
  OnSubmitToSandboxQuarantineFile = 'submitToSandboxQuarantineFile',
  OnSubmitToLabsQuarantineFile = 'submitToLabsQuarantineFile',
  OnDownloadRetrievedQuarantineFile = 'downloadRetrievedQuarantineFile',
  OnDeletedRetrievedQuarantineFile = 'deleteRetrievedQuarantineFile',
}
